export const contactsData = {
    email: "priyanka.bed@outlook.com",
    phone: "+49 1573 4109726",
    address: "Hafenstr. 53, 26954 Nordenham, Deutschland",  
    sheetAPI: "",
};
